import { css } from '@emotion/react';
import { Textarea, tokens } from '@hotjar/hotsauce';
import { useFormContext } from 'react-hook-form';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { S } from './StyledFormComponents';

interface MoreDetailsQuestionProps {
  isSubmitting: boolean;
  isDisabled: boolean;
}

export const MoreDetailsQuestion = ({
  isSubmitting,
  isDisabled,
}: MoreDetailsQuestionProps): JSX.Element => {
  const { errors, register } = useFormContext();
  const { t } = useTranslationWithPrefix('checkout:churn.surveyv2');
  return (
    <S.Field
      labelText={t('label-more-details')}
      inputId="more-details-long"
      size="l"
      isInvalid={'moreDetails' in errors}
      css={css`
        & > label {
          color: ${isDisabled ? tokens.color.text_disabled : tokens.color.text_default};
        }
      `}
    >
      {!isDisabled && (
        <Textarea
          id="more-details-long"
          name="moreDetails"
          ref={register()}
          isInvalid={'moreDetails' in errors}
          isDisabled={isSubmitting}
          maxLength={1500}
          rows={4}
        />
      )}
    </S.Field>
  );
};
